export default {
    data() {
        return {};
    },
    methods: {
        getAvailableAgreementsAddOns(agreementId, userType) {
            return new Promise((resolve) => {
                this.agreementAddOnsPickup = [];
                this.agreementAddOnsDropoff = [];
                axios.get(`/agreement-add-on-list/${agreementId}`, {params: {userType: userType}})
                    .then(({data}) => {
                        data['agreementAddOns'].forEach((agreementAddOn) => {
                            if (agreementAddOn.type === this.tripTypePickup) {
                                this.agreementAddOnsPickup.push(agreementAddOn);
                            } else if (agreementAddOn.type === this.tripTypeDropoff) {
                                this.agreementAddOnsDropoff.push(agreementAddOn);
                            }
                        });
                    }).catch((error) => {
                    console.log(error.response);
                }).finally(() => {
                    resolve();
                });
            })
        }
    },
};
